<div class="search-outer">
    <small>{{ languageService.languageJSON.Global_SearchBy}}: </small>
    <mat-select [(value)]="selectedSearchField" panelClass="panel-search-by">
        <mat-option *ngFor="let searchField of searchFields | listFieldsSearchBy" [value]="searchField.Id" selected>{{
            searchField.DisplayName }}
        </mat-option>
    </mat-select>

    <div class="search-input" *ngIf="!getDateInterval() && !getBooleanSelector()">
        <input class="search-list" name="searchText" [(ngModel)]="searchText"
            [placeholder]="languageService.languageJSON.Global_SearchList" (keyup.enter)="applySearchFilter()">
        <div [hidden]="searchText==''" class="clear-icon" (click)="searchText=''">×</div>
        <div class="search-icon-outer" (click)="applySearchFilter()">
            <img class="search-icon" src="assets/icons/search-line.svg" />
        </div>
    </div>

    <div class="custom-input" *ngIf="getDateInterval()">
        <mat-form-field class="hidden">
            <mat-label>{{languageService.languageJSON.MultipleSearchComponent_DateInterval}}</mat-label>
            <mat-date-range-input [rangePicker]="picker" readonly [max]="maxDate">
                <input matStartDate placeholder="Start date" (dateChange)="onStartDateChange($event)">
                <input matEndDate placeholder="End date" (dateChange)="onEndDateChange($event)">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>

        <div class="search-icon-outer" (click)="applySearchFilter()">
            <img class="search-icon" src="assets/icons/search-line.svg" />
        </div>
    </div>

    <div class="custom-input" *ngIf="getBooleanSelector()">
        <mat-select [(value)]="booleanValue" panelClass="panel-search-by">
            <mat-option value="0">{{ languageService.languageJSON.Global_No }}</mat-option>
            <mat-option value="1">{{ languageService.languageJSON.Global_Yes }}</mat-option>
        </mat-select>
        <div class="search-icon-outer" (click)="applySearchFilter()">
            <img class="search-icon" src="assets/icons/search-line.svg" />
        </div>
    </div>
</div>